<div *ngIf="showMachine === false" class="container-fluid">
  <!-- <app-pagetitle title="Products" [breadcrumbItems]="breadCrumbItems"></app-pagetitle> -->

  <div class="row">

    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div>
            <div class="row">
              <div class="col-md-6">

              </div>

              <div class="col-md-6">
                <div class="d-flex align-items-center justify-content-end">
                  <!-- Champ de recherche -->
                  <div class="form-inline">
                    <div class="search-box ms-2">
                      <div class="position-relative">
                        <input [(ngModel)]="searcheMachine" (input)="searchByName()" type="text" class="form-control rounded" placeholder="Rechercher par nom">
                        <i class="mdi mdi-magnify search-icon"></i>
                      </div>
                    </div>
                  </div>

                  <!-- Icône panier -->
                  <div style="cursor: pointer;" class="cart-icon-container ms-4" (click)="showCart()">
                    <i class="mdi mdi-cart-outline" style="font-size: 32px;"></i>
                    <span class="cart-badge">{{ totalItems }}</span>
                  </div>
                </div>


              </div>

            </div>
            <div class="row g-0">
              <p-carousel [value]="filteredMachines" [numVisible]="3" [numScroll]="1" [responsiveOptions]="responsiveOptions">
                <ng-template pTemplate="item" let-item>
                  <div *ngIf="filteredMachines && filteredMachines.length > 0">
                    <div style="cursor: pointer;"(click)="addItemToCart(item)" class="product-box">
                      <div class="product-img">
                        <div class="product-ribbon badge bg-dark">
                          {{ item?.types_machine?.nom }}
                        </div>
                        <img class="img-fluid mx-auto d-block product-image" [src]="item.image" alt="">
                      </div>
            
                      <div class="text-center">
                        <h5 class="font-size-15">
                          <a href="javascript: void(0);" class="text-dark">{{ item.nom }}</a>
                        </h5>
                        <h5 class="mt-3 mb-0">
                          <span class="text-muted me-2">{{ item.montant }} fcfa / {{ item?.etats_machine?.nom }}</span>
                        </h5>
                        <div class="d-flex justify-content-end">
                          <button  class="btn btn-circle ms-3 d-flex justify-content-center"
                            type="button" style="background-color: #578D63;">
                            <i class="mdi mdi-plus"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </p-carousel>
            </div>
            <div *ngIf="!filteredMachines || filteredMachines.length === 0" class="row">
              <!-- Skeleton 1 -->
              <div class="col-md-3">
                <div class="product-box">
                  <div class="product-img">
                    <p-skeleton shape="rectangle" width="100%" height="200px"></p-skeleton> <!-- Skeleton image -->
                  </div>
                </div>
              </div>
            
              <!-- Skeleton 2 -->
              <div class="col-md-3">
                <div class="product-box">
                  <div class="product-img">
                    <p-skeleton shape="rectangle" width="100%" height="200px"></p-skeleton>
                  </div>
                </div>
              </div>
            
              <!-- Skeleton 3 -->
              <div class="col-md-3">
                <div class="product-box">
                  <div class="product-img">
                    <p-skeleton shape="rectangle" width="100%" height="200px"></p-skeleton>
                  </div>
                </div>
              </div>
            
              <!-- Skeleton 4 -->
              <div class="col-md-3">
                <div class="product-box">
                  <div class="product-img">
                    <p-skeleton shape="rectangle" width="100%" height="200px"></p-skeleton>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end row -->

</div> <!-- container-fluid -->


<p-toast position="top-center" />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>